<div class="row">
  <div class="col-md-5">
    <label>Vessels</label>
  </div>
  <div class="col-md-6 d-flex justify-content-start">
    <app-select [(ngModel)]="vesselType" id="vesselType" [options]="vesselTypes" [formatter]="vesselTypesFormatter">
    </app-select>
  </div>
  <div class="col-md-1 d-flex justify-content-start">
    <button class="btn">
      <span class="fa fa-plus text-secondary" (click)="addVessel()"></span>
    </button>
  </div>
</div>
<br>
@for (vessel of vessels; track vessel; let i = $index) {
  <div class="row">
    @if (vessel.vesselType === 'ENI') {
      <app-visit-exemptions-vessel-barge
        [formBarge]="vessels[i]"
        [vesselPrefix]="vesselPrefixes[i]"
        (removeBarge)="removeVessel(i)">
      </app-visit-exemptions-vessel-barge>
    }
    @if (vessel.vesselType === 'IMO') {
      <app-visit-exemptions-vessel-ship
        [formShip]="vessels[i]"
        [vesselPrefix]="vesselPrefixes[i]"
        [shipLabelTooltip]="shipLabelTooltip"
        (removeShip)="removeVessel(i)">
      </app-visit-exemptions-vessel-ship>
    }
  </div>
}
<br>

